import { RefObject, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * Focuses `ref` when the URL carries `focus=<name>`, then drops the param so a
 * reload or Back doesn't focus it again. It is how a link lands you in a box
 * ready to type, e.g. the sidebar's per-site search opening the home search.
 */
export default function useFocusFromParam(ref: RefObject<HTMLElement | null>, name: string) {
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if (searchParams.get('focus') !== name) return
    ref.current?.focus()
    const next = new URLSearchParams(searchParams)
    next.delete('focus')
    setSearchParams(next, { replace: true })
  }, [searchParams])
}
